import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H4 } from 'UIComponents/elements/headings';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';

// @ts-expect-error: no types
import { useHideDialog } from '../../../dialog/ducks';
import { ShareViaWizardSteps } from '../constants';
import SharingMethodStepContainer from './SharingMethodStep/SharingMethodStepContainer';
import ConfigurationStepContainer from './ConfigurationStep/ConfigurationStepContainer';
import { useShareViaSettings } from './ShareViaSettingsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareViaContentSteps = {
  [ShareViaWizardSteps.sharingMethodStep]: SharingMethodStepContainer,
  [ShareViaWizardSteps.configurationStep]: ConfigurationStepContainer
};
const ShareViaDialog = () => {
  const hideDialog = useHideDialog();
  const {
    stepIndex
  } = useShareViaSettings();
  const ShareViaContent = ShareViaContentSteps[stepIndex];
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    "data-test-id": "share-report-dialog",
    width: 600,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.shareVia.dialog.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: hideDialog
      })]
    }), /*#__PURE__*/_jsx(ShareViaContent, {})]
  });
};
export default ShareViaDialog;